import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: IUserData = (() => {
  if (typeof window !== "undefined") {
    const persistedState = localStorage.getItem("__redux__user__");
    if (persistedState !== null) {
      return JSON.parse(persistedState);
    } else {
      return {
        id_user: 0,
        isLogin: false,
        name: "",
        surname: "",
        email: "",
      };
    }
  } else {
    return {
      id_user: 0,
      isLogin: false,
      name: "",
      surname: "",
      email: "",
    };
  }
})();

const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setIsLogin: (state, action: PayloadAction<{ isLogin: boolean }>) => {
      state.isLogin = action.payload.isLogin;
    },
    setUserData: (
      state,
      action: PayloadAction<{
        id_user: number;
        name: string;
        email: string;
        surname: string;
      }>
    ) => {
      state.id_user = action.payload.id_user;
      state.name = action.payload.name;
      if (action.payload.email !== "") {
        state.email = action.payload.email;
      }
      state.surname = action.payload.surname;
      if (typeof window !== "undefined") {
        localStorage.setItem("__redux__user__", JSON.stringify(state));
      }
    },
    updateData: (state, action: PayloadAction<Partial<IUserData>>) => {
      if (action.payload.id_user !== undefined) {
        state.id_user = action.payload.id_user;
      }
      if (action.payload.name !== undefined) {
        state.name = action.payload.name;
      }
      if (action.payload.email !== undefined) {
        state.email = action.payload.email;
      }
      if (action.payload.surname !== undefined) {
        state.surname = action.payload.surname;
      }

      localStorage.setItem("__redux__user__", JSON.stringify(state));
    },

    clearUserData: (state) => {
      state.id_user = 0;
      state.isLogin = false;
      state.name = "";
      state.email = "";
      state.surname = "";
    },
  },
});

export const { setUserData, clearUserData, setIsLogin, updateData } =
  userDataSlice.actions;
export default userDataSlice.reducer;
